export default __webpack_public_path__ + "static/media/outreach.83721350.svg";